import React from 'react';
import { Hero } from './Hero';
import { Capabilities } from './Capabilities';
import { CTA } from './CTA';
export function ECommerce() {
  return <div className="min-h-screen w-full bg-white" data-id="element-454">
      <Hero data-id="element-455" />
      <Capabilities data-id="element-456" />
      <CTA data-id="element-457" />
    </div>;
}